export const CREATE_TRADE_UNION = 'createTradeUnion';
export const CREATE_TRADE_UNION_ADMIN = 'createTradeUnionAdmin';
export const DELETE_TRADE_UNION_ADMIN = 'deleteTradeUnionAdmin';
export const CHECK_CARD_UNIQUENESS = 'checkCardUniqueness';
export const GET_USER_PERMISSIONS = 'getUserPermissions';
export const CHECK_LOCATION_LABEL_UNIQUENESS = 'checkLocationLabelUniqueness';
export const REQUEST_VERIFICATION_CODE_BY_ADMIN = 'requestVerificationCodeByAdmin';
export const CREATE_PROFILE_BY_ADMIN = 'createProfileByAdmin';
